import { parseSchema } from "../schemaParser.js";
import { isArrayField, isObjectField, isParentField } from "../typeGuards.js";
/**
 * Creates a blank state for the form. Prefer createBlankStateFromSchema for a
 * typed form state.
 *
 * @param fields The fields to create the state for.
 * @returns The blank state.
 */
export function createBlankState(fields) {
    const blankState = {};
    for (const field of fields) {
        if (field.field === "_id")
            continue;
        if (isParentField(field)) {
            if (isObjectField(field))
                blankState[field.field] = createBlankState(field.children);
            else if (isArrayField(field))
                blankState[field.field] = [];
        }
        else if (field.defaultValue) {
            blankState[field.field] = field.defaultValue;
        }
        else if (!field.settings?.hide) {
            switch (field.definition.typeName) {
                case "ZodBoolean":
                    blankState[field.field] = false;
                    break;
                case "ZodNumber":
                    blankState[field.field] = 0;
                    break;
                default:
                    blankState[field.field] = "";
            }
        }
    }
    return blankState;
}
/**
 * Creates a blank state for the form from a schema.
 *
 * @template TSchemaShape The shape of the schema.
 * @param schema The schema to create the state for.
 * @returns The blank state.
 */
export function createBlankStateFromSchema(schema) {
    const fields = parseSchema(schema).fields;
    return createBlankState(fields);
}
//# sourceMappingURL=initialState.js.map